export const URL = 'https://trixie-be.ithreexglobal.com';
export const URL_SECURITY = 'https://molibdeno-be.ithreexglobal.com'

